<script>
import useMobileStyle from '@/mixins/useMobileStyle';
import bem from '@/utils/bem';
import UploadFiles from '@/components/ux/upload/Upload-files.vue';
import { mapActions, mapState } from 'vuex';
import ButtonDefault from '@/components/buttons/button/Button-default.vue';
import StarIcon from '@/components/svg/starIcon/Star-icon.vue';
import { ColorPicker } from 'vue3-colorpicker';
import isUrl from '@/utils/isUrl';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import styles from './style.scss';
import convertToPrice from '../../../utils/convertToPrice';
import BANNER_DEFAULT from './constants';

const b = bem('top-banner-with-rate', styles);

export default {
  name: 'HeaderComponent',
  components: {
    RightOutlined,
    LeftOutlined,
    ColorPicker,
    ButtonDefault,
    UploadFiles,
    StarIcon,
  },
  mixins: [useMobileStyle],
  props: {
    currentPage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultOptions: BANNER_DEFAULT,
      id: null,
      name: 'headerBlock',
      title: '',
      titleMobile: '',
      description: '',
      descriptionMobile: '',
      buttonText: '',
      buttonTextMobile: '',
      imageUrl: undefined,
      imageUrlMobile: undefined,
      visibleImage: undefined,
      visibleImageMobile: undefined,
      desktopImage: [],
      mobileImage: [],
      backgroundColor: '',
      backgroundColorMobile: '',
      goldTextMobile: '',
      reviewsRate: 5,
      products: [],
      options: [],
      beforeText: '',
      afterText: '',
      goldText: '',
      goldTextSlide: '',
      goldTextSlideMobile: '',
      price: 0,
      additionalDiscount: 0,
      mainProduct: undefined,
      selectedProductValues: undefined,
      optionsForProduct: [],
      selectedOptionsForMainProduct: undefined,
      productId: 0,
      optionId: 0,
      isPreview: false,
      isMobile: false,
      slides: [],
      indexOfSlide: 0,
      optionsForSlide: [],
      error: {
        image: false,
        imageMobile: false,
        goldTextSlide: false,
        goldTextSlideMobile: false,
      },
    };
  },
  methods: {
    convertToPrice,
    b,
    ...mapActions({
      getProductListForPromoAction: 'products/getProductListForPromo',
      getPageContentAction: 'pageContent/getPageContent',
      createOrEditPageContentAction: 'pageContent/createOrEditPageContent',
      createOrEditSlideAction: 'pageContent/createOrEditSlide',
      deleteSlideAction: 'pageContent/deleteSlide',
    }),
    checkForm() {
      this.isPreview = false;
    },
    checkDesktopReview() {
      this.isPreview = true;
      this.isMobile = false;
    },
    checkMobileReview() {
      this.isPreview = true;
      this.isMobile = true;
    },
    checkImage(image, defaultValue) {
      if (isUrl(image)) {
        return [image];
      }
      return defaultValue;
    },
    checkMainProduct() {
      this.mainProduct = this.productList.find((item) => item.id === this.productId);
      if (this.mainProduct && this.mainProduct.name) {
        if (this.mainProduct.name === 'photo_art') {
          this.optionsForProduct = [...this.mainProduct.options.map((item) => ({
            label: `${item.frameColor.name} ${item.frameSize.name} ${item.frameOrientation}`,
            value: item.id,
          }))];
        } else {
          this.optionsForProduct = [...this.mainProduct.options.map((item) => ({
            label: item.displayName,
            value: item.id,
          }))];
        }
      }
    },
    clearProduct() {
      this.selectedProductValues = '';
      this.selectedOptionsForMainProduct = '';
      this.productId = 0;
      this.optionId = 0;
    },
    addSlide() {
      this.slides = [
        ...this.slides, {
          imageUrl: undefined,
          imageUrlMobile: undefined,
          goldTextSlide: '',
          goldTextSlideMobile: '',
        },
      ];
      this.indexOfSlide = this.slides.length - 1;
    },
    deleteSlide() {
      if (this.slides[this.indexOfSlide].id) {
        this.deleteSlideAction(this.slides[this.indexOfSlide].id);
      }
      this.slides = this.slides.filter((_, index) => index !== this.indexOfSlide);
      this.indexOfSlide = 0;
      this.getPageContentAction(this.currentPage.value);
    },
    saveSlide() {
      const payload = {
        page: this.currentPage.value,
        imageUrl: this.imageUrl,
        imageUrlMobile: this.imageUrlMobile,
        goldText: this.goldTextSlide,
        goldTextMobile: this.goldTextSlideMobile,
      };
      if (this.slides && this.slides.length && this.slides[this.indexOfSlide].id) {
        payload.id = this.slides[this.indexOfSlide].id;
      } else {
        payload.contentId = this.id;
      }
      this.createOrEditSlideAction(payload);
    },
    saveData() {
      const data = {
        name: this.name,
        pageKey: this.currentPage.value,
        title: this.title,
        titleMobile: this.titleMobile,
        description: this.description,
        descriptionMobile: this.descriptionMobile,
        buttonText: this.buttonText,
        buttonTextMobile: this.buttonTextMobile,
        imageUrl: [''],
        imageUrlMobile: [''],
        backgroundColor: this.backgroundColor,
        backgroundColorMobile: this.backgroundColorMobile,
        beforeText: this.beforeText,
        afterText: this.afterText,
        goldText: this.goldText,
        productId: this.productId,
        optionId: this.optionId,
        videoUrl: '',
        isShowVideo: false,
        index: 0,
        blocks: this.blocks,
      };
      const payload = {
        id: this.id,
        page: this.currentPage.value,
        params: data,
      };
      this.createOrEditPageContentAction(payload);
    },
  },
  computed: {
    ...mapState({
      productList: (state) => state.products.productList,
      pageContent: (state) => state.pageContent.pageContent,
    }),
  },
  mounted() {
    this.getProductListForPromoAction();
    this.getPageContentAction(this.currentPage.value);
  },
  watch: {
    currentPage(newV, prewV) {
      if (newV !== prewV) {
        this.getPageContentAction(newV.value);
      }
    },
    productList(newV, prewV) {
      if (newV && newV !== prewV && this.productList && this.productList.length) {
        const productsWithOptions = newV.filter((item) => item.options.length > 0);
        this.products = productsWithOptions.map((item) => ({
          label: item.displayName,
          value: item.id,
        }));
        this.checkMainProduct();
      }
    },
    selectedProductValues(newV) {
      if (newV && this.productList && this.productList.length) {
        this.productId = newV;
        this.checkMainProduct();
      }
    },
    selectedOptionsForMainProduct(newV) {
      if (newV && this.productList && this.productList.length) {
        this.optionId = newV;
        const checkedOption = this.mainProduct.options.filter((option) => option.id === newV)[0];
        this.price = checkedOption.price;
        this.additionalDiscount = checkedOption.additionalDiscount;
      }
    },
    pageContent(newV) {
      if (newV && Object.keys(newV).length) {
        const headerBlock = newV.filter((block) => block.name === 'headerBlock')[0];
        this.id = headerBlock.id;
        this.title = headerBlock.title;
        this.titleMobile = headerBlock.titleMobile;
        this.description = headerBlock.description;
        this.descriptionMobile = headerBlock.descriptionMobile;
        this.buttonText = headerBlock.buttonText;
        this.buttonTextMobile = headerBlock.buttonTextMobile;
        this.backgroundColor = headerBlock.backgroundColor;
        this.backgroundColorMobile = headerBlock.backgroundColorMobile;
        this.beforeText = headerBlock.beforeText;
        this.afterText = headerBlock.afterText;
        this.goldText = headerBlock.goldText;
        this.productId = headerBlock.productId;
        this.optionId = headerBlock.optionId;
        this.selectedProductValues = headerBlock.productId ? headerBlock.productId : '';
        this.selectedOptionsForMainProduct = headerBlock.optionId ? headerBlock.optionId : '';
        this.slides = newV.find((block) => block.name === 'headerBlock').blocks;
        if (this.slides.length > 0) {
          this.imageUrl = this.slides[this.indexOfSlide].imageUrl;
          this.imageUrlMobile = this.slides[this.indexOfSlide].imageUrlMobile;
          this.goldTextSlide = this.slides[this.indexOfSlide].goldText;
          this.goldTextSlideMobile = this.slides[this.indexOfSlide].goldTextMobile;
          this.visibleImage = this.checkImage(this.slides[this.indexOfSlide].imageUrl, '');
          this.desktopImage = this.checkImage(this.slides[this.indexOfSlide].imageUrl, []);
          this.visibleImageMobile = this.checkImage(this.slides[this.indexOfSlide].imageUrlMobile, '');
          this.mobileImage = this.checkImage(this.slides[this.indexOfSlide].imageUrlMobile, []);
        } else {
          this.imageUrl = '';
          this.imageUrlMobile = '';
          this.goldTextSlide = '';
          this.goldTextSlideMobile = '';
          this.visibleImage = '';
          this.desktopImage = [];
          this.visibleImageMobile = '';
          this.mobileImage = [];
        }
      } else {
        this.id = '';
        this.title = '';
        this.titleMobile = '';
        this.description = '';
        this.descriptionMobile = '';
        this.buttonText = '';
        this.buttonTextMobile = '';
        this.imageUrl = '';
        this.imageUrlMobile = '';
        this.backgroundColor = '#293241';
        this.backgroundColorMobile = '#ffffff';
        this.goldTextMobile = '';
        this.beforeText = '';
        this.afterText = '';
        this.goldText = '';
        this.productId = 0;
        this.optionId = 0;
        this.selectedProductValues = '';
        this.selectedOptionsForMainProduct = '';
        this.visibleImage = '';
        this.desktopImage = [];
        this.visibleImageMobile = '';
        this.mobileImage = [];
      }
      this.optionsForProduct = [];
    },
    desktopImage(newV) {
      if (typeof newV === 'object' && newV.length === 0) {
        this.visibleImage = this.defaultOptions.imageUrl;
        this.imageUrl = '';
      }
    },
    mobileImage(newV) {
      if (typeof newV === 'object' && newV.length === 0) {
        this.visibleImageMobile = this.defaultOptions.imageUrlMobile;
        this.imageUrlMobile = '';
      }
    },
    indexOfSlide(newV, prewV) {
      if (newV !== prewV) {
        this.imageUrl = this.slides[this.indexOfSlide].imageUrl;
        this.imageUrlMobile = this.slides[this.indexOfSlide].imageUrlMobile;
        this.goldTextSlide = this.slides[this.indexOfSlide].goldText;
        this.goldTextSlideMobile = this.slides[this.indexOfSlide].goldTextMobile;
        this.visibleImage = this.checkImage(this.slides[this.indexOfSlide].imageUrl, '');
        this.desktopImage = this.checkImage(this.slides[this.indexOfSlide].imageUrl, []);
        this.visibleImageMobile = this.checkImage(this.slides[this.indexOfSlide].imageUrlMobile, '');
        this.mobileImage = this.checkImage(this.slides[this.indexOfSlide].imageUrlMobile, []);
      }
    },
    slides: {
      handler(newV, prewV) {
        if (newV && newV !== prewV) {
          this.optionsForSlide = newV.map((_, index) => ({
            label: index + 1,
            value: index,
          }));
        }
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div class="top-buttons">
    <a-button
      size="large"
      class='buttons-menu-item'
      @click="checkForm()"
      :type="!isPreview ? 'primary' : 'default'"
    >
      Form for data
    </a-button>
    <a-button
      size="large"
      class='buttons-menu-item'
      @click="checkDesktopReview()"
      :type="isPreview && !isMobile ? 'primary' : 'default'"
    >
      Desktop Preview
    </a-button>
    <a-button
      size="large"
      class='buttons-menu-item'
      @click="checkMobileReview()"
      :type="isPreview && isMobile ? 'primary' : 'default'"
    >
      Mobile Preview
    </a-button>
  </div>
  <div  v-if="!isPreview" class="wrap">
    <div class="row">
      <div class="column">
        <h4>Desktop Title:</h4>
        <a-input
          placeholder="Enter here desktop title"
          style="width: 552px"
          v-model:value="title"
        />
      </div>
      <div class="column">
        <h4>Mobile Title:</h4>
        <a-input
          placeholder="Enter here mobile title"
          style="width: 552px"
          v-model:value="titleMobile"
        />
      </div>
    </div>
    <div class="row">
      <div class="column">
        <h4>Desktop Description:</h4>
        <a-textarea
          placeholder="Enter here desktop description"
          style="width: 552px"
          v-model:value="description"
          :auto-size="{ minRows: 2, maxRows: 5 }"
        />
      </div>
      <div class="column">
        <h4>Mobile Description:</h4>
        <a-textarea
          placeholder="Enter here mobile description"
          style="width: 552px"
          v-model:value="descriptionMobile"
          :auto-size="{ minRows: 2, maxRows: 5 }"
        />
      </div>
    </div>
    <div class="row">
      <div class="column">
        <div class="column">
          <h4>Desktop button text:</h4>
          <a-input
            placeholder="Enter here desktop button text"
            style="width: 552px"
            v-model:value="buttonText"
          />
          <span class="placeholder">
            If button text is empty - button don't watch.
          </span>
        </div>
        <div class="column">
          <h4>Mobile button text:</h4>
          <a-input
            placeholder="Enter here mobile button text"
            style="width: 552px"
            v-model:value="buttonTextMobile"
          />
          <span class="placeholder">
            If mobile button text is empty - button watch with desktop button text.
          </span>
        </div>
        <h4>Before price text:</h4>
        <a-input
          placeholder="Enter here before price text"
          style="width: 552px"
          v-model:value="beforeText"
        />
        <div class="row">
          <div class="column" style="width: 200px">
            <h4>Select product:</h4>
            <a-select
              style="width: 200px"
              :options="products"
              placeholder="Select product..."
              v-model:value="selectedProductValues"
            />
          </div>
          <div style="padding-top: 17px">
            <a-button
              type="primary"
              @click="clearProduct()"
            >X</a-button>
          </div>
          <div class="column" style="width: 200px">
            <h4>Select options:</h4>
            <a-select
              style="width: 200px"
              :options="optionsForProduct"
              v-model:value="selectedOptionsForMainProduct"
              placeholder="Select options..."
            />
          </div>
        </div>
        <h4>After price text:</h4>
        <a-input
          placeholder="Enter here after price text"
          style="width: 552px"
          v-model:value="afterText"
        />
        <h4>Under price text:</h4>
        <a-input
          placeholder="Enter here under price text"
          style="width: 552px"
          v-model:value="goldText"
        />
        <div class="row">
          <div class="column">
            <h4>Desktop background color:</h4>
            <color-picker v-model:pureColor="backgroundColor" />
          </div>
          <div class="column">
            <h4>Mobile background color:</h4>
            <color-picker v-model:pureColor="backgroundColorMobile" />
          </div>
        </div>
      </div>
      <div class="column">
        <h4>Slider's list:</h4>
        <div class="row">
          <a-select
            style="width: 200px"
            :options="optionsForSlide"
            v-model:value="indexOfSlide"
          />
          <a-button
            type="primary"
            @click="saveSlide()"
          >
            Save slide
          </a-button>
          <a-button
            @click="addSlide()"
          >
            Add new slide
          </a-button>
          <a-button
            type="primary"
            :disabled="slides.length < 2"
            @click="deleteSlide()"
          >X</a-button>
        </div>
        <div class="row">
          <div class="column">
            <h4>Download image for desktop:</h4>
            <upload-files
              :files="desktopImage"
              :is-multiple="false"
              :on-change="(value) => {
                this.desktopImage = value;
                this.imageUrl = value;
              }"
            />
          </div>
          <div class="column">
            <h4>Download image for mobile:</h4>
            <upload-files
              :files="mobileImage"
              :is-multiple="false"
              :on-change="(value) => {
                this.mobileImage = value
                this.imageUrlMobile = value;
              }"
            />
          </div>
        </div>
        <div class="row">
          <div class="column" style="width: 250px">
            <h4>Desktop gold text:</h4>
            <a-input
              placeholder="Enter here desktop gold text"
              style="width: 250px"
              v-model:value="goldTextSlide"
            />
          </div>
          <div class="column" style="width: 250px">
            <h4>Mobile gold text:</h4>
            <a-input
              placeholder="Enter here mobile gold text"
              style="width: 250px"
              v-model:value="goldTextSlideMobile"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row button">
      <a-button
        @click="saveData()"
        type="primary"
      >
        Save
      </a-button>
    </div>
  </div>
  <div v-if="isPreview" :class="b('', { isMobile })">
    <div class="wrapper">
      <div :class="b('button', { right: true })">
        <a-button
          type="primary"
          size="large"
          @click="() => {
            this.indexOfSlide = this.indexOfSlide - 1;
            if (this.indexOfSlide === -1) {
              this.indexOfSlide = this.slides.length - 1;
            }
          }"
        >
          <template #icon>
            <LeftOutlined />
          </template>
        </a-button>
      </div>
      <div>
        <div :class="b('container', { isMobile })">
          <img
            :src="isMobile
          ? visibleImageMobile || defaultOptions.blocks[0].imageUrlMobile
          : visibleImage || defaultOptions.blocks[0].imageUrl"
            alt="banner"
            :class="b('image', { isMobile })"
          >
          <div
            :class="b('info-block', { isMobile })"
            :style="{
          background: isMobile
            ? backgroundColorMobile || defaultOptions.backgroundColorMobile
            : backgroundColor || defaultOptions.backgroundColor
        }"
          >
            <div
              v-if="isMobile"
              :class="b('gold-line', { isMobile })"
            >
              {{ goldTextSlideMobile || goldTextSlide
            || defaultOptions.blocks[0].goldTextMobile }}
            </div>
            <div :class="b('info-block-content')" >
              <h1 :class="b('title', { isMobile })" >
                {{ isMobile
                ? titleMobile || defaultOptions.titleMobile
                : title || defaultOptions.title
                }}
              </h1>
              <div :class="b('description', { isMobile })">
                {{ isMobile
                ? descriptionMobile || defaultOptions.descriptionMobile
                : description || defaultOptions.description
                }}
              </div>
              <div
                v-if="optionId"
                :class="b('price-text', { isMobile })"
              >
                {{ beforeText || defaultOptions.beforeText }}
                <template v-if="additionalDiscount">
                  <span :class="b('price', { isMobile })" >{{ convertToPrice(price) }}</span>
                  <span :class="b('price-discount', { isMobile })">
                {{ convertToPrice(price - additionalDiscount) }}
              </span>
                </template>
                <span
                  v-else
                  :class="b('price-discount', { isMobile })"
                >{{ convertToPrice(price) }}</span>
                {{ afterText || defaultOptions.afterText }}
              </div>
            </div>
            <button-default
              v-if="buttonText"
              :class-name="b('button', { isMobile })"
              :is-mobile="isMobile"
              :click="() => {}"
              :children="isMobile
            ? buttonTextMobile || buttonText
            : buttonText"
            />
            <div :class="b('stars-block')" v-if="!isMobile">
              <div :class="b('stars')">
                <StarIcon :class="b('star')" fill="#d7e8f0" v-for="id in reviewsRate" :key="id"/>
              </div>
              <div :class="b('rate-text')" >2203 5-star reviews</div>
            </div>
          </div>
        </div>
        <div
          v-if="!isMobile"
          :class="b('gold-line')"
        >
          {{ goldTextSlide || defaultOptions.blocks[0].goldText }}
        </div>
      </div>
      <div :class="b('button', { left: true })">
        <a-button
          type="primary"
          size="large"
          @click="() => {
            this.indexOfSlide = this.indexOfSlide + 1;
            if (this.indexOfSlide === this.slides.length) {
              this.indexOfSlide = 0;
            }
          }"
        >
          <template #icon>
            <RightOutlined />
          </template>
        </a-button>
      </div>
    </div>
  </div>

</template>

<style scoped lang="scss">
@import 'src/styles/variables.scss';
@import 'src/styles/media.scss';
@import 'src/styles/fonts.scss';

.top-buttons {
  width: 1200px;
  margin: 50px auto;
  padding: 0 20px;
}

.buttons-menu-item {
  margin-right: 50px;
}

.wrap{
  width: 1200px;
  margin: 50px auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
}

.row {
  width: 552px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 50px;
  align-items: center;
}

.mini-row {
  width: 250px;
}

.column {
  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 5px;
  margin-bottom: 10px;
}

.placeholder {
  font-size: 12px;
  font-style: italic;
}

.button {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}

h4 {
  width: 250px;
}

.wrapper {
  display: flex;
  flex-direction: row;
  gap: 25px;
  align-items: center;
}

.top-banner-with-rate {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  padding: 20px 0;
  background: $athens-gray-color;
  &_isMobile {
    padding: 20px 0;
    background: $athens-gray-color;
  }

  &__container {
    width: 1544px;
    height: 596px;
    display: flex;
    justify-content: right;
    position: relative;
    background-color: $jagged_ice;
    padding: 8px;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(1544);
      height: vw-full(596);
      padding: vw-full(8);
    }

    &_isMobile {
      width: 360px;
      position: relative;
      margin: 0 auto;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      height: fit-content;
    }
  }

  &__image {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    &_isMobile {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      position: initial;
      display: block;
      object-fit: cover;
      object-position: center;
    }
  }

  &__info-block {
    height: 100%;
    width: 613px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(613);
    }

    &_isMobile {
      display: flex;
      width: 100%;
      z-index: 3;
      height: fit-content;
    }
  }

  &__info-block-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding: 0 17px;

    @include mediaMinMax(1025, $normal) {
      padding: 0 vw-full(17);
    }

    @include media($small) {
      padding: 0;
    }
  }

  &__title {

    text-shadow: 0 2px 2px rgba(43, 53, 67, 0.42);
    font-weight: 700;
    line-height: 47px;
    text-align: center;
    color: $white-color;
    white-space: pre-wrap;
    font-size: 40px;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    margin: 67px 0 30px;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(40);
      line-height: vw-full(47);
      margin: vw-full(67) 0 vw-full(30);
    }

    &_isMobile {
      width: 100%;
      color: $ebony-clay-gray-color;
      font-size: 27px;
      line-height: 32px;
      padding: 0 14px;
      margin: 34px auto 20px auto;
    }
  }

  &__description {
    font-size: 16px;
    text-align: center;
    line-height: 21.5px;
    color: $jagged_ice;
    white-space: pre-wrap;
    margin-bottom: 42px;
    padding: 0 50px;
    height: fit-content;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(16);
      line-height: vw-full(21.5);
      margin-bottom: vw-full(42);
      padding: 0 vw-full(50);
    }

    &_isMobile {
      width: 100%;
      color: $main-gray-color;
      white-space: initial;
      margin-bottom: 17px;
      padding: 0 17px;
      font-size: 15px;
      line-height: 20px;
    }
  }

  &__price-text {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 1;
    letter-spacing: normal;
    text-align: center;
    color: $white-color;
    text-transform: uppercase;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(16);
      margin-bottom: vw-full(40);
    }

    &_isMobile {
      color: $main-gray-color;
      font-size: 13px;
      margin-bottom: 20px;
    }
  }

  &__price {
    position: relative;
    margin-left: 5px;
    margin-right: 10px;

    &::before {
      content: '';
      position: absolute;
      display: block;
      height: 1px;
      width: 100%;
      background-color: $white-color;
      top: 50%;
      left: -1px;
    }

    &_isMobile {
      &::before {
        background-color: $main-gray-color;
      }
    }
  }

  &__price-discount {
    color: $tacao;
    margin-right: 5px;

    &_isMobile {
      color: $horizon;
      font-weight: 700;
    }
  }

  &__button {
    margin: 0 auto ;

    @include mediaMinMax(1025, $normal) {
      margin: 0 auto ;
    }

    &_isMobile {
      margin: 0 auto 34px;
    }
  }

  &__stars-block {
    cursor: pointer;
    display: flex;
    align-items: baseline;
    justify-content: center;
    margin: 20px 0;

    @include mediaMinMax(1025, $normal) {
      margin: vw-full(20) 0;
    }
  }

  &__stars {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 106px;
    margin-right: 22px;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(106);
      margin-right: vw-full(22);
    }
  }

  &__star {
    width: 16px;
    height: 16px;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(16);
      height: vw-full(16);
    }
  }

  &__rate-text {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: center;
    color: $jagged_ice;
    text-transform: uppercase;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(16);
    }
  }

  &__star-second-text {
    text-transform: uppercase;
    color: $jagged_ice;
  }

  &__gold-line {
    height: 48px;
    padding: 16px 0 16px 28px;
    background-image: linear-gradient(to right, #eec586, rgba(215, 232, 240, 0.02));
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: left;
    color: $ebony-clay-gray-color;
    text-transform: uppercase;
    width: 1544px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(1544);
      font-size: vw-full(20);
      padding: vw-full(16) 0 vw-full(16) vw-full(28);
    }

    &_isMobile {
      width: 100%;
      z-index: 3;
      background-color: $white-color;
      height: 35px;
      font-size: 12px;
      padding: 11px 0 14px 10px;
    }

    &_desk {
      display: none;
    }

    &_mob {
      display: none;
      @include media($small) {
        display: flex;
      };

      @include mediaMinMax(481, $small) {
        top: vw-mobile(-35);
      }

      @include media($mini) {
        top: -35px;
      }
    }
  }

  &__blue-stripe {
    display: none;

    @include mediaMinMax(481, $small) {
      display: flex;
      height: vw-mobile(8);
      width: 100%;
      box-shadow: 5.7px 8.2px 29px 0 rgba($black-color, 0.15);
      background-image: linear-gradient(to right, $horizon, $white-color);
    }

    @include media($mini) {
      display: flex;
      height: 8px;
      width: 100%;
      box-shadow: 5.7px 8.2px 29px 0 rgba($black-color, 0.15);
      background-image: linear-gradient(to right, $horizon, $white-color);
    }
  }
}
</style>
